import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { AccountConvert } from '../models';
import { Observable } from 'rxjs';

@Injectable()
export class ConvertAccountService extends CrudBaseService<AccountConvert> {
    constructor(httpClient: HttpClient) {
        super('/account', httpClient);
    }

    convert(accountID: string, data: AccountConvert): Observable<any> {
        return this.httpClient.patch(`${this.basePath}/${accountID}/convert`, {
            data
        });
    }
}
